// Import States.
import {
	AppState,
	BroadLineOfBusinessState,
	getInitialBroadLineOfBusinessState,
} from '@app/redux/states';
// Import Actions.
import {
	BroadLineOfBusinessAction,
} from '@app/redux/actions';


/**
 * This handles initializing the state.
 * @param state
 * @param action
 */
let initializeState = (state: AppState, action: BroadLineOfBusinessAction): AppState => {
	let newState: AppState = { ...state };
	// Initialize the state.
	if (newState.possibleBroadLinesOfBusiness[action.broadLineOfBusiness] === undefined) {
		newState.possibleBroadLinesOfBusiness[action.broadLineOfBusiness] = getInitialBroadLineOfBusinessState();
	}
	else {
		newState.possibleBroadLinesOfBusiness[action.broadLineOfBusiness] = { ...newState.possibleBroadLinesOfBusiness[action.broadLineOfBusiness] }
	}

	return newState;
}

/**
 * Query the state.
 * @param state
 * @param action
 */
let queryBroadLineOfBusinessState = (state: AppState, action: BroadLineOfBusinessAction): BroadLineOfBusinessState => {
	return state.possibleBroadLinesOfBusiness[action.broadLineOfBusiness];
}

// Export initializers.
export {
	initializeState,
}

// Export queries.
export {
	queryBroadLineOfBusinessState,
};